// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lp_Y","rootNoMargin":"styles_rootNoMargin__3UmzE"};